/* eslint-disable */ import { assertNumber, composedOfComponent, distanceDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const kickPlateComponents = [
    attachComponent.withComponent(composedOfComponent, '$bulkOrderItems', true).withEntity('KickPlate').attach(memoEval((self)=>self.$bulkOrderItems.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachComponent.withComponent(distanceDimensionComponent, 'horizontalLength', true).withEntity('KickPlate').attach(memoEval((self)=>[
            self.horizontalLength,
            self.$maxHorizontalLength
        ], (horizontalLength, $maxHorizontalLength)=>({
            value: horizontalLength,
            min: 400,
            max: $maxHorizontalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'verticalLength', true).withEntity('KickPlate').attach(memoEval((self)=>[
            self.verticalLength,
            self.$maxVerticalLength
        ], (verticalLength, $maxVerticalLength)=>({
            value: verticalLength,
            min: 100,
            max: $maxVerticalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            verticalLength: state.value
        };
    })
];

//# sourceMappingURL=kick-plate.js.map